import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, imgSrc } from "../lib/api";
import MarqueeStrip from "../components/MarqueeStrip";
import ArticleCard from "../components/ArticleCard";
import PodcastPlayer from "../components/PodcastPlayer";
import ConfessionBox from "../components/ConfessionBox";

export default function Home() {
  const [latest, setLatest] = useState([]);
  const [episodes, setEpisodes] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data));
    api.get("/articles", { params: { limit: 6 } }).then((r) => setLatest(r.data));
    api.get("/podcast/episodes", { params: { limit: 6 } }).then((r) => setEpisodes(r.data));
  }, []);

  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section className="relative">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-12 lg:pt-20 pb-12">
          <div className="flex items-end justify-between gap-4">
            <div>
              {settings?.hero_kicker ? (
                <span data-testid="hero-kicker" className="pill-tag bg-[#FA6157] mb-5">
                  {settings.hero_kicker}
                </span>
              ) : null}
              <h1
                data-testid="hero-title"
                className="font-display-black text-6xl sm:text-8xl lg:text-[10rem] tracking-tighter"
              >
                {settings?.hero_title_1 || "INTIMITÉ"}
                <br />
                <span className="text-[#0A8074]">{splitHeroTitle2(settings)[0]}</span>{" "}
                {splitHeroTitle2(settings)[1]}
                <span className="text-[#FA6157]">.</span>
              </h1>
            </div>
            <div className="hidden lg:block shrink-0">
              <img
                src="/logo-bonsang.png"
                alt="Bon Sang cherry mascot"
                className="w-44 h-44 cherry-bounce"
              />
            </div>
          </div>
        </div>
      </section>

      <MarqueeStrip
        items={["BON SANG !", "INTIMITÉ SANS TABOUS", "JARDIN INTIME", "CHUT ! ON TESTE"]}
        bg="#FFD01E"
        color="#050505"
      />

      {/* CONFESSION INTIME */}
      <ConfessionBox settings={settings} />

      <MarqueeStrip
        items={["BON SANG !", "TOUS LES VENDREDIS", "PODCAST", "ON DIT TOUT"]}
        bg="#FA6157"
        color="#FFFDF7"
        reverse
        slow
      />

      {/* PODCAST */}
      {episodes[0] && <PodcastPlayer episode={episodes[0]} settings={settings} />}

      {/* TOUT CHAUD TOUT CRU */}
      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-20">
        <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
          <div>
            <p className="uppercase text-xs font-bold tracking-widest mb-3">À la une</p>
            <h2 className="font-display-black text-5xl sm:text-7xl">
              Tout chaud, <span className="text-[#FA6157]">tout cru</span>.
            </h2>
          </div>
          <Link
            to="/category/way-of-life"
            className="brutal-btn brutal-btn-lavender"
            data-testid="see-all-articles"
          >
            Tout voir <ArrowRight size={16} />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </section>

      <MarqueeStrip items={["RIRE", "PARLER", "AIMER", "SE RESPECTER", "RECOMMENCER"]} bg="#FA6157" color="#FFFDF7" />

      {/* MANIFESTO */}
      <section className="py-20" style={{ background: "#D9C5FD" }}>
        <div className="mx-auto max-w-[1100px] px-5 lg:px-10">
          <p data-testid="manifesto-kicker" className="uppercase text-xs font-bold tracking-widest text-[#FA6157]">
            {settings?.manifesto_kicker || "Notre credo"}
          </p>
          <p
            data-testid="manifesto-text"
            className="font-display-black text-4xl sm:text-6xl lg:text-7xl mt-4 leading-[0.95] text-[#050505]"
          >
            {settings?.manifesto_text ||
              "Bon sang ! On parle d'intimité comme on en parle entre potes, à 2h du mat, après le 3e verre."}
          </p>
        </div>
      </section>
    </div>
  );
}

function splitHeroTitle2(settings) {
  const t = settings?.hero_title_2 || "sans tabous.";
  // Try to split first word as accent color, rest in normal. e.g. "sans tabous." -> ["sans","tabous."]
  const idx = t.indexOf(" ");
  if (idx === -1) return [t.replace(/\.$/, ""), ""];
  return [t.slice(0, idx), t.slice(idx + 1).replace(/\.$/, "")];
}
